const useThemeUiConfig = () => ({
  preset: {},
  prismPreset: {},
});

export default useThemeUiConfig;
